import { useContext } from 'react';
import { Context } from '../Context';

export interface Tracking {
  sendReadyEvent(): void;
  registerImpressionTracking(): void;
}

/**
 *
 * @param ref reference to the DOM element of the related component
 * @param componentNameWithDashes name of the component with dashes as seperator (known as "kebab case")
 * @param attributes attributes that get passed into the related component tracking data
 * @returns
 */
export function useTracking(
  ref: React.MutableRefObject<null>,
  componentNameWithDashes: string,
  attributes?: {
    version?: string;
    implementer?: number;
    [key: string]: unknown;
  },
): Tracking {
  const { trackingService } = useContext(Context);
  const componentNameWithSpaces = componentNameWithDashes.replace(/-/g, ' ');
  const defaultComponentAdditions = {
    componentInfo: {
      // not accepted by tracking lib
      // componentID: 'bla',
    },
    attributes: {
      version: __FEATURE_APP_VERSION__,
      ...attributes,
    },
  };

  return {
    sendReadyEvent: () => {
      if (trackingService) {
        const readyEvent = {
          event: {
            attributes: {
              componentName: componentNameWithDashes,
              elementName: '',
              label: '',
              clickID: '',
              pos: '',
              targetURL: '',
              value: '',
            },
            eventInfo: {
              eventAction: 'feature_app_ready',
              eventName: `${componentNameWithSpaces} - feature app ready`,
            },
          },
          componentUpdate: defaultComponentAdditions,
        };
        trackingService.track(readyEvent);
      }
    },
    registerImpressionTracking: () => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (trackingService && ref.current) {
        trackingService.registerImpressionTracking(ref.current, () => {
          return {
            event: {
              attributes: {
                componentName: componentNameWithDashes,
                elementName: '',
                label: '',
                clickID: '',
                pos: '',
                targetURL: '',
                value: '',
              },
              eventInfo: {
                eventAction: 'impression',
                eventName: `${componentNameWithSpaces} - impression`,
              },
            },
            componentUpdate: defaultComponentAdditions,
          };
        });
      }
    },
  };
}
